import Bugsnag from '@bugsnag/expo';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { APITypes } from '../primary-record-types';
import { Environment } from '../hooks/useEnvironment';
import { initialNavigationUrl } from './initialNavigationUrl';
import Constants from 'expo-constants';

const isRunningInExpoGo = Constants.appOwnership === 'expo';

const userSessionStartedHash: Record<string, true> = {};

export type MaybeStartBugsnagUserSessionArgs = {
    user: APITypes.userService.MeResponse;
    isE2E: boolean;
    environment: Environment;
};

export const maybeStartBugsnagUserSession = ({ user, isE2E, environment }: MaybeStartBugsnagUserSessionArgs) => {
    try {
        if (isE2E) {
            return;
        }

        if (window?.location?.hostname === 'localhost') {
            return;
        }

        // expo go or expo development mode
        if (isRunningInExpoGo || __DEV__) {
            return;
        }

        if (userSessionStartedHash[user.userId]) {
            return;
        }

        Bugsnag.start({
            // nosemgrep
            apiKey: 'ca0d74383a5800ebebe2d42a03f7ce6c',
            plugins: [new BugsnagPluginReact()],
            user: {
                id: user.userId,
                email: user.email,
                name: user.firstName + ' ' + user.lastName,
            },
            releaseStage: environment,
            onError: (event) => {
                event.addMetadata('App Context', {
                    initialUrl: initialNavigationUrl,
                });
            },
        });

        userSessionStartedHash[user.userId] = true;
    } catch (error) {
        console.error('Failed to start Bugsnag user session', error);
    }
};

export const notifyBugsnag = (error: Error) => {
    try {
        if (isRunningInExpoGo || __DEV__) return;

        Bugsnag.notify(error);
    } catch (error) {
        console.error('Failed to notify Bugsnag', error);
    }
};
